// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { locationSearchFormStyles } from "@eisinc/Overrides/Components/LocationSearchForm";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import Phone from "@insite/mobius/Icons/Phone";
import { RadioStyle } from "@insite/mobius/Radio";
import { css } from "styled-components";

locationSearchFormStyles.spinner = {
    color: "primary.main",
    css: css`
        margin: auto;
    `,
};

locationSearchFormStyles.distanceUnitOfMeasureRadioGroup = {};

locationSearchFormStyles.searchButtonGridItem = {
    width: [12, 12, 12, 12, 3],
    css: css`
        justify-content: flex-end;
        align-items: flex-end;
    `,
};

locationSearchFormStyles.distanceUnitOfMeasureGridItem = {
    width: 8,
    css: css`
        align-items: center;
        justify-content: flex-end;
    `,
};

locationSearchFormStyles.distanceUnitOfMeasureRadioGroup = {
    css: css`
        display: flex;
        gap: 4px;
        flex-direction: row;
        ${RadioStyle} + ${RadioStyle} {
            margin-top: 0;
        }
    `,
};

locationSearchFormStyles.searchResultsText = {};

locationSearchFormStyles.locationNameLink = {
    color: "primary",
    typographyProps: {
        weight: fontConfig.weight.medium,
        ellipsis: true,
    },
    css: css`
        text-decoration: none;

        &,
        &:focus {
            outline: 0;
        }
    `,
};

locationSearchFormStyles.searchResultAddressInfoGridItem = {
    width: 11,
    css: css`
        flex-direction: column;
    `,
};

locationSearchFormStyles.searchResultContentGridItem = { width: [5, 2, 2, 2, 2] };

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = { width: [12, 3, 2, 2, 2] };

locationSearchFormStyles.searchResultDistanceGridItem = {
    width: [11, 4, 4, 4, 4],
};

locationSearchFormStyles.searchResultPhoneLink = {
    icon: {
        iconProps: {
            src: Phone,
            size: 14,
        },
        position: "left",
    },
    css: css`
        margin-top: 5px;
    `,
};
